import { FeaturePropertyTypesProps, IconColorsProps, LocationTypesProps, LocationCertificateStatusTypesProps, MapClickTypesProps, MapMarkerTypesProps, MapPanelStatesProps, MapPropertiesProps, ShipTypeGroupsProps, ShipTypesProps } from "./MapPropertiesServiceProps"

class MapPropertiesService {

    static get panelStates(): MapPanelStatesProps {
        return {
            Settings: "Settings",
            Search: "Search",
            Empty: "Empty",
            PilotCertificateCoastalSegments: "PilotCertificateCoastalSegments",
        }
    }

    static get markerTypes(): MapMarkerTypesProps {
        return {
            Ship: "ship",
            Location: "Location",
            CertificateLocation: "CertificateLocation",
        }
    }

    static get shipTypes(): ShipTypesProps {
        return {
            PilotVessel: "PILOT_VESSEL"
        }
    }

    static get shipTypeGroups(): ShipTypeGroupsProps {
        return {
            Cargo: "CARGO",
            Tanker: "TANKER",
            Passenger: "PASSENGER",
            Fish: "FISH",
            Tug: "TUG",
            Auxilliary: "AUXILLIARY"
        }
    }

    static get iconColors(): IconColorsProps {
        return {
            Primary: 'var(--icon-primary-fill)',
            Secondary: 'var(--icon-secondary-fill)',
            Active: 'var(--icon-active-fill)',
            InActive: 'var(--icon-inactive-fill)',
            Disabled: 'var(--icon-disabled-fill)',
            Error: 'var(--icon-error-fill)',
            Warning: 'var(--icon-warning-fill)',
            Ship: 'var(--icon-ship-fill)',
            ShipDefault: 'var(--icon-ship-default-fill)',
            ShipPilotVessel: 'var(--icon-ship-pilot-vessel-fill)',
            ShipCargo: 'var(--icon-ship-cargo-fill)',
            ShipTanker: 'var(--icon-ship-tanker-fill)',
            ShipPassenger: 'var(--icon-ship-passenger-fill)',
            ShipFish: 'var(--icon-ship-fish-fill)',
            ShipTug: 'var(--icon-ship-tug-fill)',
            ShipAuxillary: 'var(--icon-ship-auxillary-fill)',
            Pin: 'var(--icon-pin-fill)',
            PinStart: 'var(--icon-pin-start-fill)',
            PinStop: 'var(--icon-pin-stop-fill)',
            PinLocation: 'var(--icon-pin-location-fill)',
            AssignmentConfirmed: 'var(--icon-assignment-confirmed-fill)',
            AssignmentAssigned: 'var(--icon-assignment-assigned-fill)'
        }
    }

    static get locationTypes(): LocationTypesProps {
        return {
            Harbour: "HARBOUR",
            Anchorage: "ANCHORAGE",
            LocationAtSea: "LOCATION_AT_SEA",
            PilotBoarding: "PILOT_BOARDING"
        }
    }

    static get locationCertificateStatusTypes(): LocationCertificateStatusTypesProps {
        return {
            HasCertificate: "HAS_CERTIFICATE",
            HasCertificateNeedTestRun: "HAS_CERTIFICATE_NEEDS_TEST_RUN",
            CertificateFrozen: "CERTIFICATE_FROZEN",
            KnowAreaSailAsLocalExpert: "KNOW_AREA_MAY_SAIL_AS_LOCAL_EXPERT",
            HasNoCertificate: "HAS_NO_CERTIFICATE",
            CertificateExpired: "CERTIFICATE_EXPIRED",
            ApprovedExpansionNeedTestRun: "APPROVED_EXPANSION_NEEDS_TEST_RUN",
        }
    }

    static get clickTypes(): MapClickTypesProps {
        return {
            Marker: "marker",
            Circle: "circle"
        }
    }

    static get properties(): MapPropertiesProps {
        return {
            SegmentFeatureType: "SegmentFeatureType",
            DefaultFillColor: "#bf9cbc",
            DefaultStrokeColor: "#333333",
            MouseOverStrokeColor: "#007d97",
            SelectedStrokeColor: "#d60f0f",
            SelectedFillColor: "#CE5456",
            DefaultOpacity: 0.35,
            PcsFeatureType: "PcsFeatureType",
            MultiFeatureType: "MultiFeatureType",
            ColorInactive: "#FF8484",
            ColorAvailable: "yellow",
            ColorSelected: "#1CA8DD",
            ColorBorder: "#0178D4",
            ColorFairwayArea: "#2d89ef",
            
            ColorFairwayAreaApplied: "#ffc40d",
            ColorFairwayAreaStrokeDark: '#d3d3d3',
            ColorFairwayAreaStroke: '#424242',

            ColorCertificateFairwayArea: "#00a300",
            ColorCertificateFairwayAreaStrokeDark: '#202020',
            ColorCertificateFairwayAreaStroke: '#424242',
            ColorCertificateAvailable: "#ff0097",
            ColorCertificateReadyForApproval: "#ffc40d",
            ColorCertificateApproved: "#00a300",

            ColorMulti: "#008B4D",
            AisVisibleAtZoom: 10,
            MarkersVisibleAtZoom: 8,
            FeaturesVisibleAtZoom: 9,
            MinimumSpeed: 0.5,
            MapControlActiveClassName: "google-map-control-active",
            FairwayAreaFeatureType: "FairwayAreaFeatureType",
            EvaluationFeatureType: "EvaluationFeatureType",
            CertificateGroupAreaFeatureType: "CertificateGroupAreaFeatureType",
            AvailableFeatureType: "AvailableFeatureType",
        }
    }

    static get featurePropertyTypes(): FeaturePropertyTypesProps {
        return {
            Group: "GROUP"
        }
    }
}

export default MapPropertiesService;

